module.exports = __webpack_public_path__ + "static/img/7.8350be7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/sp/7.png
// module id = XHOk
// module chunks = 0